import Region from "../../../../../models/Region";
import { ZYGOSITY_TYPE_INDEX } from "../../../constants/zygosity";
import { pathogenicityIndex } from "../../../constants/pathogenicity";
import { precisionIndex } from "../../../constants/dellyPrecision";
import { cnvTypeIndex } from "../../../constants/cnvTypes";
import CiPosEnd from "./CiPosEnd";

class DellyCnv {
  constructor(data = {}, chr) {
    const zyg = data.zygosity?.length ? data.zygosity[0] : 0;
    this.ciEnd = Math.abs(data.ciend);
    this.ciPos = Math.abs(data.cipos);
    this.x0 = data.pos - this.ciPos;
    this.x1 = data.end + this.ciEnd;
    this.readratio = data.reads_ratio;

    this.zygosityIndex = ZYGOSITY_TYPE_INDEX[zyg];
    this.pathoIndex = pathogenicityIndex[data?.pathogenicity];

    this.start = data?.pos;
    this.end = data?.end;
    this.typeIndex = cnvTypeIndex[data.cnv_type];
    this.precisionIndex = data.is_precise
      ? precisionIndex.precise
      : precisionIndex.imprecise;
    this.region = new Region(this.start, this.end, chr);
    this.id = `${this.region.g0}-${this.region.g1}`;
    this.original = data;

    this.ciPosRegion = new CiPosEnd(
      this.start - this.ciPos,
      this.start + this.ciPos,
      this,
      chr
    );
    this.ciEndRegion = new CiPosEnd(
      this.end - this.ciEnd,
      this.end + this.ciEnd,
      this,
      chr
    );
  }

  isDeletion() {
    return this.typeIndex === cnvTypeIndex.deletion;
  }
}

export default DellyCnv;
